import useResources from "./use-resources";
import { findAndUpdate } from "../utils/index.jsx";

const ROOT_PATH = "files";

export default function useFiles({
  tenantId,
  propertyId,
  propertyFolderId,
  profileBailleurId,
  isTenant = false,
}) {
  const {
    resources: files,
    error,
    isLoading,
    update,
    del,
    mutate,
    axios,
  } = useResources(ROOT_PATH, {
    params: {
      id_tenant: tenantId,
      id_bien: propertyId,
      id_property_folder: propertyFolderId,
      id_profile_bailleur: profileBailleurId,
    },
  });

  function addFiles(files) {
    return mutate(
      async (currentFiles) => {
        const response = await axios.post(ROOT_PATH, files, {
          params: {
            id_tenant: tenantId,
            is_tenant: isTenant,
            id_bien: propertyId,
            id_property_folder: propertyFolderId,
            id_profile_bailleur: profileBailleurId,
          },
        });
        return [...currentFiles, ...response.data];
      },
      { revalidate: false },
    );
  }

  async function sendToLaPoste(fileId, values) {
    let newResource;
    await mutate(
      async (current) => {
        const response = await axios.post(`/laposte/send`, {
          id_file: fileId,
          ...values,
        });
        newResource = response.data;
        return findAndUpdate(
          current,
          (resource) => resource.id === fileId,
          newResource,
        );
      },
      { revalidate: false },
    );
    return newResource;
  }
  async function sendToElectronicSigning(fileId) {
    let newResource;
    await mutate(
      async (current) => {
        const response = await axios.get(`oodrive/sign/${fileId}`);
        newResource = response.data;
        return findAndUpdate(
          current,
          (resource) => resource.id === fileId,
          newResource,
        );
      },
      { revalidate: false },
    );
    return newResource;
  }
  async function cancelElectronicSigning(fileId) {
    let newResource;
    await mutate(
      async (current) => {
        const response = await axios.get(`oodrive/${fileId}/cancel`);
        newResource = response.data;
        return findAndUpdate(
          current,
          (resource) => resource.id === fileId,
          newResource,
        );
      },
      { revalidate: false },
    );
    return newResource;
  }
  async function relanceSignataire(fileId, signataireId) {
    await axios.get(`oodrive/${fileId}/relance/${signataireId}`);
  }

  // Suppression groupée en une seule transaction côté back, puis un seul rafraîchissement.
  async function deleteFiles(fileIds) {
    await axios.post(`${ROOT_PATH}/delete`, { file_ids: fileIds });
    await mutate(
      (current) => (current ?? []).filter((file) => !fileIds.includes(file.id)),
      { revalidate: false },
    );
  }

  async function updateFiles(fileIds, values) {
    const updated = await Promise.all(
      fileIds.map((fileId) =>
        axios.put(`${ROOT_PATH}/${fileId}`, values).then((res) => res.data),
      ),
    );
    const byId = new Map(updated.map((file) => [file.id, file]));
    await mutate(
      (current) => (current ?? []).map((file) => byId.get(file.id) ?? file),
      { revalidate: false },
    );
  }

  return {
    files,
    error,
    isLoading,
    mutate,
    addFiles,
    deleteFile: del,
    deleteFiles,
    updateFile: update,
    updateFiles,
    sendToElectronicSigning,
    cancelElectronicSigning,
    sendToLaPoste,
    relanceSignataire,
  };
}
